import { useTheme } from '@vimeo/bokeh';

export const useIsBokeh = () => {
  const theme = useTheme();
  return Boolean(theme.styles?.global.body.fontFamily.includes('ABCRepro'));
};
